import TradeOrdersPage from '@/views/trade/TradeOrdersPage'

export default function TradeScreen() {
  return <TradeOrdersPage />
}
